<div style="background: white; border-radius: 16px; overflow: hidden;">

  <!-- Header -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0;">
    <div style="display: flex; align-items: center; gap: 12px;">
      <div [style.background]="data.type === 'UPDATE' ? '#eff6ff' : '#f0fdf4'"
        [style.border]="data.type === 'UPDATE' ? '1px solid #bfdbfe' : '1px solid #bbf7d0'"
        style="border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
        <mat-icon [style.color]="data.type === 'UPDATE' ? '#2563eb' : '#1C593D'"
          style="font-size: 24px; width: 24px; height: 24px;">
          {{ data.type === 'UPDATE' ? 'edit' : 'add_circle' }}
        </mat-icon>
      </div>
      <div>
        <h2 style="margin: 0; font-size: 1.1rem; font-weight: 800; color: #1e5a3f;">
          {{ data.type === 'UPDATE' ? 'Actualizar cuenta de retiro' : 'Registrar cuenta de retiro' }}
        </h2>
        <p style="margin: 2px 0 0; font-size: 0.8rem; color: #6b7280;">
          {{ data.type === 'UPDATE' ? 'Modifique los datos de la cuenta' : 'Complete los datos de la nueva cuenta' }}
        </p>
      </div>
    </div>
  </div>

  <!-- Content scrollable -->
  <div style="padding: 20px 24px; max-height: 60vh; overflow-y: auto;">

    <!-- Aviso -->
    <div *ngIf="data.type != 'UPDATE'"
      style="margin-bottom: 20px; padding: 12px 16px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; display: flex; align-items: center; gap: 8px;">
      <mat-icon style="color: #16a34a; font-size: 18px; width: 18px; height: 18px;">info</mat-icon>
      <span *ngIf="!preselectedCountry" style="color: #1e5a3f; font-size: 0.8rem; font-weight: 500;">
        Recuerda: Solo puedes realizar retiros a cuentas bancarias propias
      </span>
      <span *ngIf="preselectedCountry" style="color: #1e5a3f; font-size: 0.8rem; font-weight: 500;">
        Registra la cuenta bancaria chilena del beneficiario
      </span>
    </div>

    <!-- Form -->
    <div *ngIf="formCuenta">
      <form [formGroup]="formCuenta">

        <div class="form-row">
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>País</mat-label>
            <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">public</mat-icon>
            <mat-select required formControlName="pais" (selectionChange)="getBanks()">
              <mat-option>Seleccione país</mat-option>
              <mat-option *ngFor="let pais of paisesActivos" [value]="pais.codigoPais">
                {{ pais.nombre | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Aviso campos bloqueados -->
        <div *ngIf="camposBloqueados"
          style="margin-bottom: 16px; padding: 10px 14px; background: #fffbeb; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 8px; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="color: #d97706; font-size: 18px; width: 18px; height: 18px;">lock</mat-icon>
          <span style="color: #92400e; font-size: 0.8rem; font-weight: 500;">
            Los datos del titular se han completado automáticamente y no pueden ser editados
          </span>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Nombre y apellido</mat-label>
            <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">person</mat-icon>
            <input matInput formControlName="alias" placeholder="Titular de la cuenta">
            <mat-icon *ngIf="camposBloqueados" matSuffix style="color: #d97706; font-size: 16px; width: 16px; height: 16px;">lock</mat-icon>
          </mat-form-field>
        </div>

        <div class="form-row two-cols">
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Tipo documento</mat-label>
            <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">badge</mat-icon>
            <mat-select required formControlName="tipoId">
              <mat-option>Tipo documento</mat-option>
              <mat-option *ngFor="let tipo of tiposID" [value]="tipo">{{ tipo }}</mat-option>
            </mat-select>
            <mat-icon *ngIf="camposBloqueados" matSuffix style="color: #d97706; font-size: 16px; width: 16px; height: 16px;">lock</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Número identificación</mat-label>
            <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">fingerprint</mat-icon>
            <input matInput formControlName="numeroId" placeholder="Ej: 12345678-9">
            <mat-icon *ngIf="camposBloqueados" matSuffix style="color: #d97706; font-size: 16px; width: 16px; height: 16px;">lock</mat-icon>
          </mat-form-field>
        </div>

        <div class="form-row" [ngClass]="{'two-cols': !isChile}">
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Banco</mat-label>
            <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">account_balance</mat-icon>
            <mat-select required formControlName="banco">
              <mat-option>Seleccione el banco</mat-option>
              <mat-option *ngFor="let banco of bancos" [value]="banco">
                {{ banco.nombre | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="!isChile" appearance="outline" class="modern-field">
            <mat-label>Código</mat-label>
            <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">tag</mat-icon>
            <input matInput [disabled]="true" [value]="formCuenta.get('banco')?.value?.codigoBanco ?? ''" placeholder="Código banco">
          </mat-form-field>
        </div>

        <div class="form-row two-cols">
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Tipo de cuenta</mat-label>
            <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">credit_card</mat-icon>
            <mat-select required formControlName="tipoCuentaId">
              <mat-option>Tipo de cuenta</mat-option>
              <mat-option *ngFor="let tipo of tiposCuentas" [value]="tipo.tipoCuentaID">
                {{ tipo.nombre | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Número de cuenta</mat-label>
            <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">pin</mat-icon>
            <input matInput formControlName="numeroCuenta" placeholder="Ej: 00000000000000">
          </mat-form-field>
        </div>

        <!-- Validation error -->
        <div *ngIf="formCuenta.get('numeroCuenta')?.invalid && (formCuenta.get('numeroCuenta')?.dirty || formCuenta.get('numeroCuenta')?.touched)"
          style="background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 8px; padding: 8px 12px; margin-top: 4px;">
          <span style="color: #991b1b; font-size: 0.8rem; font-weight: 500;">
            {{ isChile ? 'Máximo 20 dígitos, solo números' : 'Máximo 20 dígitos, sin caracteres especiales' }}
          </span>
        </div>

      </form>
    </div>
  </div>

  <!-- Buttons -->
  <div style="display: flex; gap: 16px; padding: 16px 24px; border-top: 1px solid #e5e7eb; justify-content: flex-end; flex-wrap: wrap;">
    <button type="button" (click)="onNoClick()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 28px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      Cancelar
    </button>
    <button type="button" (click)="guardarCuentaRetiro()"
      style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
      Guardar
    </button>
  </div>

</div>
